<template>
  <div>
    <!-- 下级机构结算 -->
    <subordinate v-if="userInfo.userType == 3"></subordinate>
    <org v-else></org>
  </div>
</template>

<script>
import org from './org';
import subordinate from './subordinate';
export default {
  components: {
    org,
    subordinate
  },
  data() {
    return {
      userInfo: JSON.parse(window.localStorage.getItem('userInfo'))
    };
  }
};
</script>
